<div class="facilities">
  <h5 class="hotel-heading">Property extras for your enjoyment</h5>
  <div>
    <div *ngIf="top5Facilities && top5Facilities.length > 0" class="facilities__top5 flex-col gap-05">
      <span *ngFor="let facility of top5Facilities.slice(0, 5)">{{ facility.name }}</span>
    </div>
    <button class="show__more-info" (click)="triggerMenu(true)" *ngIf="totalFacilities > 5">
      Show all <span>{{ totalFacilities }}</span>

      <svg class="arrow-right" width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.126 1.971L6.08 6.41l-4.954 4.562" stroke="#2C6DA9" stroke-width="2" />
      </svg>
    </button>
  </div>

  <!-- <div *ngIf="facilities && facilities.general.length > 0" class="">
            <h5>General</h5>
            <ul class="amenities">
                <li class="amenities__item" *ngFor="let facility of facilities.general">
                    <p>{{facility}}</p>
                </li>
            </ul>
        <div *ngIf="facilities && facilities.activities.length > 0" class="">
            <h5>Activities</h5>
            <ul class="amenities">
                <li class="amenities__item" *ngFor="let activity of facilities.activities">
                    <p>{{activity}}</p>
                </li>
            </ul>
        </div>
        <div *ngIf="facilities && facilities.services.length > 0" class="hotelFacilityColumn col-md-4 col-12 col-sm-12">
            <h5>Services</h5>
            <ul class="amenities">
                <li class="amenities__item" *ngFor="let service of facilities.services">
                    <p>{{service}}</p>
                </li>
            </ul>
        </div>
    </div> -->

  <div id="md-modalFacilities" class="md-modal md-effect-12">
    <div class="md-content">
      <div class="modal__title-container">
        <h4>Amenities and Services</h4>
        <button type="button" title="Close Button" (click)="triggerMenu(false)" class="md-close">
          <svg width="23" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M.483.483a1.642 1.642 0 0 1 2.325 0L11.5 9.178 20.192.483a1.644 1.644 0 1 1 2.326 2.325L13.823 11.5l8.695 8.692a1.643 1.643 0 1 1-2.326 2.326L11.5 13.823l-8.692 8.695a1.644 1.644 0 1 1-2.325-2.326L9.178 11.5.483 2.808a1.642 1.642 0 0 1 0-2.325Z"/>
          </svg>
        </button>
      </div>
      <div *ngIf="facilities && facilities.general.length > 0" class="">
        <h5 class="modal__h5">General</h5>
        <ul class="amenities">
          <li class="amenities__item" *ngFor="let facility of facilities.general">
            <p>{{facility}}</p>
          </li>
        </ul>
      </div>
      <div *ngIf="facilities && facilities.activities.length > 0" class="">
        <h5 class="modal__h5">Activities</h5>
        <ul class="amenities">
          <li class="amenities__item" *ngFor="let activity of facilities.activities">
            <p>{{activity}}</p>
          </li>
        </ul>
      </div>
      <div *ngIf="facilities && facilities.services.length > 0" class="">
        <h5 class="modal__h5">Services</h5>
        <ul class="amenities">
          <li class="amenities__item" *ngFor="let service of facilities.services">
            <p>{{service}}</p>
          </li>
        </ul>
      </div>
      <div *ngIf="isVilla">
        <h5 class="modal__h5">Villa Room Specific</h5>
        <div class="amenities">
          <span class="amenities__item" *ngFor="let facility of facilitiesSingle">
            {{ facility.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>